import React from 'react';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { IAdminSignInFormModel } from '../../form-services/admin-signin-iface';
import { getPageStyles } from './style';
import { BwjCard, BwjGrid, Col, Row } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { BwjTextField } from '../../../../framework/components/bwj-text-field';
import * as formService from '../../form-services/admin-signin';
import { BwjTextFieldType } from '../../../../framework/components/bwj-text-field/field-type';
import { Text } from '@fluentui/react';
import { BwjButton, BwjButtonType } from '../../../../framework/components/bwj-button';

interface IUiAdminSignInProps {
  viewState: BwjViewState;
  formModel: IAdminSignInFormModel;
  onSignIn: () => void;
}

export const UiAdminSignIn: React.FunctionComponent<IUiAdminSignInProps> = (props) => {
  const styles = getPageStyles();
  const { formModel } = props;

  return (
    <BwjViewManager
      state={props.viewState}
      loadingState={{
        message: 'One moment please...',
      }}
    >
      <div className={styles.main}>
        <BwjCard className={styles.signInPanel}>
          <BwjGrid>
            <Row bottomSpacing={Spacing.Large}>
              <Col small={12}>
                <h1 className={styles.header}>{'Admin Sign In'}</h1>
              </Col>
            </Row>
            <Row bottomSpacing={Spacing.Medium}>
              <Col small={12}>
                <BwjTextField
                  id={formService.username.id}
                  label={formService.username.description}
                  required={true}
                  input={formModel.username}
                  onUpdate={formService.username.onUpdate}
                />
              </Col>
            </Row>
            <Row bottomSpacing={Spacing.Medium}>
              <Col small={12}>
                <BwjTextField
                  id={formService.password.id}
                  label={formService.password.description}
                  required={true}
                  input={formModel.password}
                  onUpdate={formService.password.onUpdate}
                  fieldType={BwjTextFieldType.RevealablePassword}
                />
              </Col>
            </Row>
            <Row bottomSpacing={Spacing.Large}>
              <Col small={12}>
                <BwjButton
                  buttonStyle={BwjButtonType.PrimaryStandard}
                  text={'Sign In'}
                  onClick={props.onSignIn}
                />
              </Col>
            </Row>
            {formModel.signInFailed &&
            <Row bottomSpacing={Spacing.Medium}>
              <Col small={12}>
                <strong>
                  <Text variant="medium" className={styles.loginFailText}>{'Invalid username and/or password'}</Text>
                </strong>
              </Col>
            </Row>}
          </BwjGrid>
        </BwjCard>
      </div>
    </BwjViewManager>
  );
};
